import { Role } from "@models/role";
import { User } from "@models/user";

export class RolesStore {
  constructor(
    public roles: Role[] = [],
    public roleUsers: User[] = [],
  ) {}
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/store/roles.ts